import Err from '@leverege/error'
import { Plugins } from '@leverege/plugin'
import Util from './Util.js'

const View = Plugins.createView(
  'Expression.FieldParser',
  { sort : 'byNumber' }
)

export default {
  async create( model, context ) {
    const plgs = View.get()
    const parser = plgs.find( el => el.handles?.( model, context ) )
    if ( parser ) {
      return parser.parse( model, context )
    }
    return Util.handleInvalid(
      model,
      Err.illegalArgument( { message : 'no parser available', model, context } ),
      context
    )
  }
}
